<template>
  <el-card shadow="always" v-loading="loading" :body-style="{ padding: '0px' }">
    <div class="row bg-casper py-2 px-3">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="mb-0 text-white">User Management</h3>
      </div>
    </div>
    <div class="row m-4 ">
      <div class="col-12">
        <!--/businesses/create-->
        <el-table :data="businesses.data" style="width: 100%" cell-class-name="bg-lightgrey py-1">
          <el-table-column label="Accounts" prop="name">
            <template slot-scope="scope">
              <a :href="`/businesses/${scope.row.id}`" class="text-navy">{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column label="" prop="id" width="270">
            <template slot-scope="scope">
              <el-button @click="openModal($event, scope.row)" class="action-btn w-5 rounded" type="primary"
                style="width: 120px;">
                Assign access
              </el-button>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.guarantors" style="width: 100%" cell-class-name="py-1">
                <el-table-column label="First Name" prop="first_name"></el-table-column>
                <el-table-column label="Last Name" prop="last_name"></el-table-column>
                <el-table-column label="Phone" prop="phone"></el-table-column>
                <el-table-column label="Email" prop="email"></el-table-column>
                <el-table-column label="" prop="id">
                  <template slot-scope="scope">
                    <span class="user-status-badge active" v-if="scope.row.active">Active</span>
                    <span class="user-status-badge inactive" v-else>Inactive</span>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="id">
                  <template slot-scope="scope">
                    <div v-if="scope.row.user_businesses && scope.row.user_businesses.length > 0">
                      <span v-if="scope.row.user_businesses[0].status_id == 1"
                        class="user-status-badge requested text-uppercase">Requested</span>
                      <span v-if="scope.row.user_businesses[0].status_id == 2"
                        class="user-status-badge granted text-uppercase">Granted</span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <div class="py-3 d-flex justify-content-center justify-content-xl-end">
          <el-pagination small layout="prev, pager, next, total" :current-page.sync="currentPage"
            @current-change="handleCurrentChange" :background="true" :page-size="perPage"
            :page-count="businesses.last_page" :total="businesses.total" />
        </div>
      </div>
    </div>
    <business-contacts-access :initial_business="selectedBusiness" v-if="showModal"
      @close="showModal = false; selectedBusiness = null" @update="getBusinesses()"></business-contacts-access>
  </el-card>
</template>
<script>
import OttleyFormatter from "../../../mixins/OttleyFormatter";
import Business from "../../modelsPortal/Business";
import BusinessContactsAccess from './components/BusinessContactsAccess.vue';
export default {
  components: { BusinessContactsAccess },
  mixins: [OttleyFormatter],
  props: {
  },
  mounted() {
    this.getBusinesses();
  },
  data() {
    return {
      businesses: [],
      loading: false,
      statementModalShow: false,
      formModalShow: false,
      purchaseFormModalShow: false,
      selectedBusiness: null,
      page: 1,
      currentPage: 1,
      perPage: 5,
      showModal: false,
      selectedBusiness: null,
    };
  },
  methods: {
    openModal(event, business) {
      console.log(business)
      event.preventDefault();
      this.selectedBusiness = business;
      this.showModal = true;
    },
    getBusinesses(
      page = 1,
    ) {
      this.loading = true;

      let businesses = Business.page(page)
        .select('id', 'name', 'agency_id', 'business_status_id')
        .include('guarantors.userBusinesses')
        .params({ 'per_page': 10 });

      businesses
        .get()
        .then((res) => {
          this.loading = false;
          this.businesses = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    showStatementModal(event, business) {
      event.preventDefault();
      this.selectedBusiness = business;
      this.statementModalShow = true
    },
    showSaleModal(event, business) {
      event.preventDefault();
      this.selectedBusiness = business;
      this.formModalShow = true
    },
    showPurchaseModal(event, business) {
      event.preventDefault();
      this.selectedBusiness = business;
      this.purchaseFormModalShow = true
    },
    handleCurrentChange(page = 1) {
      this.getBusinesses(page);
    },
  },
};
</script>
